import { Badge, Button, Dropdown, Tabs } from 'antd';
import ArrowRightOutlineIcon from 'components/AppIcon/ArrowRightOutlineIcon';
import BellLinearIcon from 'components/AppIcon/BellLinearIcon';
import { NotificationItem } from 'features/notification/components/NotificationItem';
import { notifications } from 'features/notification/constants';
import { memo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPath } from 'routes/router-paths';

const NotificationPanel = () => {
  const [open, setOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('all');
  const navigate = useNavigate();

  return (
    <Dropdown
      open={open}
      onOpenChange={() => setOpen(prev => !prev)}
      trigger={['click']}
      dropdownRender={() => (
        <div className="w-85 rounded-[20px] rounded-se-none bg-white p-5 shadow-[0px_4px_40px_0px_rgba(0,0,0,0.15)]">
          <Tabs
            className="[&_.ant-tabs-nav]:mb-5 [&_.ant-tabs-tab]:pt-0"
            activeKey={activeTab}
            onChange={setActiveTab}
            items={[
              {
                key: 'all',
                label: <span className="text-sm">Thông báo</span>,
                children: (
                  <div className="space-y-6">
                    {notifications.map(item => (
                      <NotificationItem
                        key={item.id}
                        data={item}
                        viewMode="panel"
                      />
                    ))}
                  </div>
                ),
              },
              {
                key: 'general',
                label: <span className="text-sm">Thông báo chung</span>,
                children: (
                  <div className="py-10 text-center text-gray-400">
                    Không có thông báo
                  </div>
                ),
              },
            ]}
          />

          <div className="mt-4 flex items-center justify-center">
            <Button
              type="link"
              className="gap-3 text-sm font-medium text-primary"
              icon={<ArrowRightOutlineIcon className="h-4 w-4 -rotate-45" />}
              iconPosition="end"
              onClick={() => {
                navigate(getPath('notificationPage'));
                setOpen(false);
              }}
            >
              Xem thêm
            </Button>
          </div>
        </div>
      )}
    >
      <Badge count="+99" offset={[-6, -3]}>
        <div className="flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-full bg-[#F6F6F6] hover:bg-[#eeeeee]">
          <BellLinearIcon className="h-5 w-5 cursor-pointer text-black" />
        </div>
      </Badge>
    </Dropdown>
  );
};

export default memo(NotificationPanel);
